export enum ProductionLocation {
  BORCULO = 'Borculo',
  NOKI = 'Nordkirchen',
  ENSCHEDE = 'Enschede',
  GREGG = 'Gregg',
  NOVATEC = 'Novatec',
  BERGSMA = 'Bergsma',
  MEDDO = 'Meddo'
}
